export default __webpack_public_path__ + "img/4fd5d9afe824ea86fa9abb2eb19b4311.svg";